import type { TestFunction } from 'yup';

import { FieldErrors } from 'shared/lib/fields';

export const validateMinMaxStringNumber =
  (min: number, max: number, minMessage: string, maxMessage: string): TestFunction<string | undefined> =>
  (value, context) => {
    const numberValue = Number(value);
    if (Number.isNaN(numberValue)) {
      return context.createError({
        path: context.path,
        message: FieldErrors.notValid,
      });
    }

    if (numberValue < min) {
      return context.createError({
        path: context.path,
        message: minMessage,
      });
    }

    if (numberValue > max) {
      return context.createError({
        path: context.path,
        message: maxMessage,
      });
    }

    return true;
  };
